module.exports = __webpack_public_path__ + "assets/images/ertworld.485e19a2217657435486c0f7f250b3f7.png";